function getBasePath() {
	const baseUri = document.getElementsByTagName('base')[0].href;
	const i = baseUri.indexOf('/', 'https://'.length); // get the path part of a URL
	return baseUri.substring(i);
}

const BASE_PATH = getBasePath();
export default BASE_PATH;
